import { useRef } from 'react';

export const useFocus = <T extends HTMLElement | null = HTMLElement>() => {
  const inputRef = useRef<T | null>(null);
  const setFocus = () => {
    inputRef?.current?.focus?.();
  };

  return [inputRef, setFocus] as const;
};
